<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:40:17
 -->
<!--  -->
<template>
  <div>
    <div id="main">
      <experienceTop ref="experienceTop" :count="countTotal" :experienceTop="experienceTop" @experienceTopData="experienceTopData"/>
      <el-row>
        <experienceMain @xdTotal="xdCount" ref="experienceMain" :experienceMain="experienceMain" @experienceMainData="experienceMainData"/>
        <experienceRight @experienceRightdata="experienceRightdata" ref="experienceRight" @open="open"/>
      </el-row>
    </div>
  </div>
</template>

<script>
import experienceTop from './components/experienceTop.vue'
import experienceMain from './components/experienceMain.vue'
import experienceRight from './components/experienceRight.vue'

export default {
  data() {
    return {
      countTotal: 0,
      experienceMain: {},
      experienceTop: {}
    }
  },
  components: {
    experienceTop,
    experienceMain,
    experienceRight
  },
  mounted() {
    console.log(this.experienceMain)
  },
  methods: {
    xdCount(total) {
      this.countTotal = total
      this.$refs.experienceRight.getDzQuery({ pageNum: 1, pageSize: 200 })
      this.$refs.experienceTop.getplCount()
    },
    experienceMainData(item) {
      this.experienceMain = item
      this.experienceTop = item
      setTimeout(() => {
        this.$refs.experienceMain.getXdQuery({ pageNum: 1, pageSize: 10 })
      }, 100)
    },
    experienceRightdata(val) {
      this.experienceMain = val
      this.experienceTop = val
      setTimeout(() => {
        this.$refs.experienceMain.getXdQuery({ pageNum: 1, pageSize: 10 })
        // this.$refs.experienceMain.discuss(!1)
      }, 0)
    },
    open(index, item) {
      setTimeout(() => {
        // this.$refs.experienceMain.getXdQuery({ pageNum: 1, pageSize: 10 })
        this.$refs.experienceMain.discuss(!index, item)
      }, 0)
    },
    experienceTopData() {
      this.experienceMain = {}
      this.experienceTop = {}
      setTimeout(() => {
        this.$refs.experienceMain.getXdQuery({ pageNum: 1, pageSize: 10 })
      }, 0)
    }
  }
}
</script>

<style>
 #main {
   border-left: 10px solid #f8f8f8;
 }
</style>
